import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React from 'react';

var _excluded = ["as", "className", "xs", "sm", "md", "lg", "xl", "align", "justify", "sortValue"];
var TableData = function TableData(props, context) {
  var _classnames;
  var _props$as = props.as,
    As = _props$as === void 0 ? 'td' : _props$as,
    className = props.className,
    xs = props.xs,
    sm = props.sm,
    md = props.md,
    lg = props.lg,
    xl = props.xl,
    align = props.align,
    justify = props.justify;
    props.sortValue;
    var otherProps = _objectWithoutProperties(props, _excluded);
  var finalClasses = classnames('C-TableData', (_classnames = {
    '--lg-size-auto': lg === true
  }, _defineProperty(_classnames, "--lg-size-".concat(lg), lg && lg !== true), _defineProperty(_classnames, '--md-size-auto', md === true), _defineProperty(_classnames, "--md-size-".concat(md), md && md !== true), _defineProperty(_classnames, '--sm-size-auto', sm === true), _defineProperty(_classnames, "--sm-size-".concat(sm), sm && sm !== true), _defineProperty(_classnames, '--xl-size-auto', xl === true), _defineProperty(_classnames, "--xl-size-".concat(xl), xl && xl !== true), _defineProperty(_classnames, '--xs-size-auto', xs === true), _defineProperty(_classnames, "--xs-size-".concat(xs), xs && xs !== true), _defineProperty(_classnames, "--xs-align-".concat(align), align), _defineProperty(_classnames, "--xs-justify-".concat(justify), justify), _classnames), className);
  return /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses
  }, otherProps));
};
TableData.displayName = 'Table.Data';

export { TableData as default };
